export const detailedTransactions = {
	tabTitle: "Venta detallada",
	header: {
		title: "Informe de Venta detallada",
		subtitle:
			"Acompañe los productos vendidos y visualice sus ventas de forma detallada.",
		exportButton: "Exportar",
		exportLoading: "Exportando...",
		exportNotification:
			"el informe será generado y una vez listo será enviado a su correo electrónico ({{email}})",
	},
	inlineFilters: {
		customerPlaceholder: "Filtrar por cliente",
		employeesPlaceholder: "Filtrar por colaborador",
		paymentMethodsPlaceholder: "Filtrar por tipo de pago",
		filtersButton: "Filtros",
	},
	table: {
		dateTime: "FECHA / HORA",
		customer: "CLIENTE",
		document: "DOCUMENTO",
		seller: "COLABORADOR",
		products: "PRODUCTOS",
		paymentMethods: "FORMA DE PAGO",
		refunded: "¿REEMBOLSADO?",
		refundedBadge: "REEMBOLSADO",
		discount: "DESCUENTO",
		value: "VALOR DE LA TRANSACCIÓN",
		totalRow: "Total",
		emptyCustomer: "Venta libre",
		emptyValue: "-",
		productsCount: "{{count}} productos",
		productsCount_one: "{{count}} producto",
		productsCount_other: "{{count}} productos",
		paymentMethodsCount: "{{count}} métodos",
		paymentMethodsCount_one: "{{count}} método",
		paymentMethodsCount_other: "{{count}} métodos",
		emptyState: {
			noData: {
				title: "No se encontraron transacciones",
				description:
					"No hay transacciones registradas en el período seleccionado. Cuando se realicen nuevas ventas, aparecerán aquí.",
			},
			noFilters: {
				title: "No hay transacciones para los filtros aplicados",
				description:
					"Intenta ajustar el período, cliente, colaborador, forma de pago o sector para encontrar lo que buscas.",
			},
		},
		pagination: {
			pageSizeLabel: "Resultados por página",
		},
	},
	expandedProducts: {
		name: "Producto",
		fiscalCode: "Cód. fiscal",
		category: "Categoría",
		count: "Cant.",
		value: "Valor unit.",
		discount: "Descuento",
		total: "Total",
	},
	filterModal: {
		title: "Filtros",
		cancel: "Cancelar",
		clearFilters: "Limpiar filtros",
		apply: "Aplicar",
		filteredBy: "Filtrado por",
		filterOptionsLabel: "Opciones de filtro",
		clearSelection: "Limpiar selección",
		nav: {
			dateOrPeriod: "Fecha o período",
			operation: "Cliente y colaborador",
			payment: "Pago",
			sector: "Sector",
		},
		period: {
			today: "Hoy",
			yesterday: "Ayer",
			last30Days: "Últimos 30 días",
			customPeriod: "Período personalizado",
		},
		periodLabels: {
			today: "Hoy",
			yesterday: "Ayer",
			last_30_days: "Últimos 30 días",
			custom: "Personalizado",
		},
		activeFilterLabels: {
			period: "período",
			customer: "cliente",
			employee: "colaborador",
			payment: "pago",
			sector: "sector",
		},
		operationSection: {
			customerLabel: "Cliente",
			customerPlaceholder: "Filtrar por cliente",
			employeeLabel: "Colaborador",
			employeePlaceholder: "Filtrar por colaborador",
			noEmployeeFound: "No se encontró ningún colaborador",
		},
		paymentSection: {
			paymentLabel: "Forma de pago",
			paymentPlaceholder: "Filtrar por tipo de pago",
			noPaymentFound: "No se encontró ninguna forma de pago",
		},
		sectorSection: {
			sectorLabel: "Sector",
			sectorPlaceholder: "Filtrar por sector",
			noSectorFound: "No se encontró ningún sector",
		},
	},
};
